var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27324 1.30147H3.05101C3.4103 1.30147 3.7015 1.01026 3.7015 0.650977C3.7015 0.29169 3.4103 0.000488281 3.05101 0.000488281H0.702745C0.700793 0.000488281 0.698842 0.000921945 0.69689 0.00113877C0.656126 0.0013556 0.615579 0.00547537 0.575466 0.0132812C0.555951 0.0171842 0.537737 0.0245564 0.518656 0.0301939C0.496973 0.036482 0.474857 0.0416859 0.453824 0.0503591C0.432141 0.0594659 0.41241 0.0716084 0.392028 0.0828835C0.375332 0.0919904 0.357986 0.0993626 0.34194 0.110204C0.306814 0.133622 0.274289 0.160075 0.244584 0.189781C0.24415 0.190431 0.243283 0.190648 0.242849 0.191298C0.241548 0.192599 0.240898 0.194117 0.239597 0.195418C0.232224 0.203007 0.22637 0.212114 0.219215 0.220137C0.0856477 0.339393 0 0.510905 0 0.703884V3.05215C0 3.41144 0.291202 3.70264 0.650489 3.70264C1.00978 3.70264 1.30098 3.41144 1.30098 3.05215V2.16922L3.49616 4.36397C3.62301 4.49081 3.78975 4.55434 3.95606 4.55434C4.12236 4.55434 4.28911 4.49081 4.41617 4.36375C4.67008 4.10984 4.67008 3.69787 4.41617 3.44374L2.27324 1.30147Z",
    fill: "#F0AB2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomArrow);
export default __webpack_public_path__ + "static/media/zoom-arrow.b303fe79.svg";
export { ForwardRef as ReactComponent };